import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d390861"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "firstname",
  class: "content__page--upper__header primary-font"
}

import ContentPage from "../ContentPage.vue";
import { useScrollerStore } from "@/store/scroller";
import { onMounted, ref } from "vue";
import { useContentStore } from "@/store/content";
import { ComponentPublicInstance } from "vue";

interface HomePageStyleObject {
  top: string;
  position: string;
  right: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const scrollerStore = useScrollerStore();
const contentStore = useContentStore();

const surname = ref<HTMLElement | null>(null);

onMounted(() => {
  scrollerStore.addScrollAction(() => {
    const app = document.getElementById("app") as HTMLElement;

    const style = {
      top: "0",
      position: "absolute",
      right: "0",
    } as HomePageStyleObject;

    const innerPadding = contentStore.vmin(3);
    const outerBorder = contentStore.vmin(5);

    if (app.scrollTop >= innerHeight / 2 - outerBorder) {
      style.top = `calc(50vh - ${app.scrollTop}px + 0.3vmin)`;
      style.position = `fixed`;
      style.right = innerPadding + outerBorder + "px";
    }

    if (app.scrollTop >= innerHeight / 2 - contentStore.vmin(0.3)) {
      style.top = "0.7vmin";
      style.position = `fixed`;
      style.right = innerPadding + outerBorder + "px";
    }

    (Object.keys(style) as Array<keyof typeof style>).forEach((key) => {
      if (!surname.value) return;
      surname.value.style[key] = style[key];
    });
  });
});

return (_ctx: any,_cache: any) => {
  const _directive_glitched = _resolveDirective("glitched")!

  return (_openBlock(), _createBlock(ContentPage, {
    "wide-hr": true,
    class: "content-page__home"
  }, {
    upper: _withCtx(() => [
      _withDirectives(_createElementVNode("p", _hoisted_1, null, 512), [
        [_directive_glitched, 'timothy']
      ])
    ]),
    lower: _withCtx(() => [
      _withDirectives(_createElementVNode("p", {
        id: "surname",
        ref_key: "surname",
        ref: surname,
        class: "content__page--lower__header primary-font"
      }, null, 512), [
        [_directive_glitched, 'van der Veen']
      ])
    ]),
    _: 1
  }))
}
}

})